<template>
    <div id="autoresponder">
        <div class="legend">
            <h4><i class="icon icon-info"></i> Useful Tags</h4>
            <strong>%subject%</strong> The subject of the message sent to the autoresponder.<br />
            <strong>%from%</strong> The name of the sender of the message received by the autoresponder, if available.<br />
            <strong>%email%</strong> The incoming email sender’s address.
        </div>
        <div class="split-fields">
            <txt label="email" :append="'@' + data.domain" v-model="model.email"></txt>
            <txt label="from_email" v-model="model.from"></txt>
        </div>
        <txt label="subject" v-model="model.subject"></txt>

        <ckeditor id="reHtml" :height="'300px'" :toolbar="[['Source', 'Format'],  ['Font','FontSize'], ['Bold', 'Italic', 'SpecialChar', 'Scayt'], ['Undo', 'Redo'], ['NumberedList','BulletedList'], ['Link','Unlink'], ['Maximize'], ['Image'], ['Outdent', 'Indent', 'Styles'] ]"></ckeditor>

        <txt label="interval" append="hrs" v-model="model.interval"></txt>
        <small>How many hours between sending repeat autoresponders to the same mailer.</small>

        <div class="split-fields">
            <div class="form-group">
                <label>Start Date:</label>
                <input type="text" v-model="model.startDate" class="datepicker form-control"><br>
                <p class="instruct-sm">Leave blank for immediately.</p>
            </div>
            <div class="form-group">
                <label>End Date:</label>
                <input type="text" v-model="model.endDate" class="datepicker form-control"><br>
                <p class="instruct-sm">Leave blank for never.</p>
            </div>
        </div>
        <div class="section buttons">
            <button @click.prevent="store" class="btn btn-success btn-sm pull-right"><i class="icon icon-save"></i> Save</button>
        </div>
    </div>
</template>
<script>
    export default{
        props: {
            name: { default: '' },
            data: {
                default: {
                    domain: '',
                    id: ''
                }
            }
        },
        data() {
            return {
                model: {
                    type: 'responder',
                    email: '',
                    from: '',
                    subject: '',
                    interval: '',
                    startDate: '',
                    endDate: '',
                    html: '',
                }
            }
        },
        components: {
            'txt':      require('./form/text.vue').default,
            'ckeditor': require('../view/ckeditor/ckeditor.vue').default,
        },
        created: function () {
            this.$eventHub.$on('autoresponderSubmit', this.store);
            this.$eventHub.$on('updateCkeditorHtml', this.updateHtml);
//            $('.datepicker').datepicker();
        },
        methods: {
            store(){
                this.$store('/api/email/create/' + this.data.id, this);
            },
            updateHtml(html) {
                this.model.html = html;
            },
        }
    }
</script>
